import { ResponsiveTableCell } from '../ResponsiveTable.types';

export const SimpleCell: ResponsiveTableCell = ({ value }) => {
  return <>{value || null}</>;
};
